<template>
    <div class="force-full-height">
        <working-dues-tax-stub-partial
            :name="getDisplayName()"
            :year="year"
            :amount="getDisplayAmount()"
            type="FEDERAL"
            class="tearline"
        />
        <working-dues-tax-stub-partial
            :name="getDisplayName()"
            :year="year"
            :amount="getDisplayAmount()"
            type="PROVINCIAL"
            class="tearline"
        />
        <working-dues-tax-stub-partial
            :name="getDisplayName()"
            :year="year"
            :amount="getDisplayAmount()"
            type="PERSONAL"
        />
    </div>
</template>

<script>

    import WorkingDuesTaxStubPartial from "@/Pages/InternalPages/Reports/WorkingDuesTaxStubPartial.vue";

    export default {
        name: "WorkingDuesTaxStub",
        components: {WorkingDuesTaxStubPartial},
        props: {
            'year': {
                required: false,
                default: function () {
                    return 1969
                }
            },
            'item': {
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                filters: {
                    search: null,
                    date_deposit: null,
                    user_id: null,
                },
                fetch_data_response: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'user_last_name',   text: 'Last Name',      align: `start`,     sortable: false, filterable: false,   },
                    {value: 'user_first_name',  text: 'First Name',     align: `start`,     sortable: false, filterable: false,   },
                    {value: 'sum_dues_amount',  text: 'Amount',         align: `end`,       sortable: false, filterable: false,   },
                    {value: 'date_deposit',     text: 'Deposit Date',   align: ` d-none`,   sortable: false, filterable: true,  search: this?.filters?.date_deposit },
                    {value: 'user_id',          text: 'User ID',        align: ` d-none`,   sortable: false, filterable: true,  search: this?.filters?.user_id },

                ]
            },

        },
        methods: {
            example() {
                console.log("This is just a test")
            },
            async exportAsPdf() {
                await this.$refs.report_list.getPdf()
            },
            getDisplayName() {
                if (!this.item) {
                    return ''
                }
                return !!this.item?.user_last_name ? `${this.item?.user_last_name}, ${this.item?.user_first_name}` : this.item?.user_first_name
            },
            getDisplayAmount() {
                if (!this.item) {
                    return ''
                }
                let numeric_value = parseFloat(this.item?.sum_dues_amount)
                if (Number.isNaN(numeric_value)) {
                    return ''
                }
                let num_fixed = (Math.round(numeric_value * 100) / 100).toFixed(2)
                let num_formatted = new Intl.NumberFormat('en-CA', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(num_fixed)
                return num_formatted.replaceAll(',', ' ')
            },
        },
    }
</script>

<style>
html,body, .v-application, .v-app, .font-change {
    font-size: 10pt;
    font-family: ABCFavorit, system-ui, sans-serif !important;
}

.pagebreak {
    page-break-after: always;
    min-height: 1px;
}

.force-full-height {
    height: 100vh !important;
    width: 100vw !important;
}

.tearline {
    border-bottom: #cccccc 1px dashed;
}

@page  {
    size: letter portrait;
}

</style>
